<section
  class="flex absolute left-[4.4rem] top-[4.4rem] right-0 bottom-0"
>
  <div class="main flex flex-grow flex-column column-gap-1 overflow-auto">
    <div class="space-between-horizontal-centered">
      <span class="font-2 bold600" data-qa="kpi-bulk-request-header">Bulk request</span>
      @if (companyWrappers && companyWrappers.length) {
        <div class="centered-row-container row-gap-0p5">
          <app-button-drop-down
            data-qa="manage-periods-settings"
            [data]="buttons"
            [field]="'name'"
            [buttonType]="'grey'"
            [icon]="'calendar.svg'"
            [displayedItem]="'Manage periods'"
            [showDoubleButton]="true"
            [showDropDownIcons]="true"
            [dropDownWidth]="'width-10'"
            [size]="'small'"
            (itemEmitter)="setPeriodModal($event.action)">
          </app-button-drop-down>
          <app-button
            data-qa="kpi-bulk-request-bulk-request-button"
            [iconName]="'send.svg'"
            [type]="'accent'"
            [size]="'small'"
            [showIcon]="'left'"
            (buttonClick)="show.kpiRequestModal = true">
            Bulk request
          </app-button>
        </div>
      }
    </div>
    @if (companyWrappers && companyWrappers.length) {
      <div
        data-qa="kpi-bulk-request-table"
        class="table-fms height-unset">
        <table>
          <thead>
          <tr [ngClass]="is.collapsed ? 'short-sticky-group' : 'full-sticky-group'">
            <th class="col-three-dots"></th>
            <th class="col-company-name">
              @if (is.collapsed) {
                <div class="end-row-container">
                  <app-button
                    [type]="'grey-white'"
                    [size]="'xsmall'"
                    [iconName]="'arrow-right.svg'"
                    (buttonClick)="is.collapsed = !is.collapsed">
                    Expand
                  </app-button>
                </div>
              }
            </th>
            @if (!is.collapsed) {
              <th class="col-metrics"></th>
              <th class="sticky-position blank-space no-hover"></th>
              <th class="col-link">
                <div class="end-row-container">
                  <app-button
                    [type]="'grey-white'"
                    [size]="'xsmall'"
                    [iconName]="'arrow-left.svg'"
                    (buttonClick)="is.collapsed = !is.collapsed">
                    Collapse
                  </app-button>
                </div>
              </th>
            }
            <th class="sticky-position blank-space no-hover"></th>
            <th class="col-type"></th>
            <th class="col-permitted-period"></th>
            <th class="sticky-position blank-space no-hover"></th>
            @for (periodWrapper of periodsByYears; track periodWrapper.year) {
              @if (!periodWrapper.isShown) {
                <th class="fix-w-2p5">
                  <div class="flex justify-between items-center">
                    <span [attr.data-qa]="'kpi-bulk-request-year-header-' + periodWrapper.year">{{ periodWrapper.year }}</span>
                    <app-all-icons
                      [attr.data-qa]="'kpi-bulk-request-year-show-year-' + periodWrapper.year"
                      class="cursor-pointer"
                      iconNameAndStyling="arrow-right.svg; black-10 icon-size-1p25"
                      (click)="loadYear(periodWrapper)"></app-all-icons>
                  </div>
                </th>
              } @else {
                <th [colSpan]="periodWrapper.periods.length">
                  <div class="flex justify-between items-center pl-2">
                    <span [attr.data-qa]="'kpi-bulk-request-year-header-' + periodWrapper.year">{{ periodWrapper.year }}</span>
                    <app-all-icons
                      [attr.data-qa]="'kpi-bulk-request-year-hide-year-' + periodWrapper.year"
                      class="cursor-pointer"
                      iconNameAndStyling="arrow-left.svg; black-10 icon-size-1p25"
                      (click)="unloadYear(periodWrapper)"></app-all-icons>
                  </div>
                </th>
              }
              <th class="sticky-position blank-space no-hover z-0"></th>
            }
            <th></th>
          </tr>
          <tr [ngClass]="is.collapsed ? 'short-sticky-group' : 'full-sticky-group'">
            <th class="col-three-dots"></th>
            <th class="col-company-name">Company</th>
            @if (!is.collapsed) {
              <th class="col-metrics">Metrics</th>
              <th class="sticky-position blank-space no-hover"></th>
              <th class="col-link">
                <div class="flex flex-row items-start gap-[1rem]">
                  <app-switcher
                    data-qa="kpi-bulk-request-toggle-msl"
                    #bulkMSLToggle
                    class="small-switcher"
                    id="kpi-bulk-request-toggle-msl"
                    [formControl]="allMSLToggleForm"
                    (mouseenter)="showEnableAllMSLTooltip('kpi-bulk-request-toggle-msl')"
                    (mouseleave)="show.allMslTooltip = null"
                    (checkedChanged)="toggleMSLForAllCompanies()"
                  />
                  <span>Link</span>
                </div>
              </th>
            }
            <th class="sticky-position blank-space no-hover"></th>
            <th class="col-type">Type</th>
            <th class="col-permitted-period">
              <div class="space-between-horizontal-centered">
                <span>Permitted periods</span>
                <app-all-icons
                  data-qa="kpi-modal-bulk-icon"
                  class="clickable"
                  [iconNameAndStyling]="'calendar.svg'"
                  (click)="show.bulkMslModal = true;"
                />
              </div>
            </th>
            <th class="sticky-position blank-space no-hover"></th>
            @for (yearWrapper of periodsByYears; track yearWrapper.year) {
              @if (!yearWrapper.isShown) {
                <th class="fix-w-2p5"></th>
              } @else {
                @for (period of yearWrapper.periods; track period) {
                  <th
                    [attr.data-qa]="'kpi-bulk-request-table-header-period-' + period"
                    class="fix-w-2p5"
                    [appScrollIntoView]="period === selected.periodToScrollOnInit">
                    <div class="centered-row-container">
                      <div [attr.data-qa]="'header-date-' + period" class="flex flex-col">
                        <span [attr.data-qa]="'header-month-' + period">{{ period | date: 'MMM' }}</span>
                      </div>
                    </div>
                  </th>
                }
              }
              <th class="sticky-position blank-space no-hover z-0"></th>
            }
            <th></th>
          </tr>
          </thead>
          <tbody>
            @for (grouping of Grouping; track grouping) {
              <tr [ngClass]="is.collapsed ? 'short-sticky-group' : 'full-sticky-group'">
                <td
                  [attr.data-qa]="'kpi-bulk-request-table-hide-unhide-grouping-' + grouping"
                  class="col-three-dots"
                  (click)="show.grouping[grouping].isShown = !show.grouping[grouping].isShown">
                  <app-table-group-icon
                    [attr.data-qa]="grouping+'-show-grouping'"
                    [opened]="show.grouping[grouping].isShown"
                  />
                </td>
                <td class="col-company-name">
                  <div class="start-row-container row-gap-0p5">
                    <span [attr.data-qa]="grouping+'-grouping-name'"
                          class="bold500">
                      {{ grouping === 'tracked' ? 'Tracked' : 'Not tracked' }}
                    </span>
                    <span
                      [attr.data-qa]="'kpi-bulk-request-table-grouping-amount-' + show.grouping[grouping].amount"
                      class="caption-2 bold500 bg-black-4 br-0p5 padding-0p15625-0p3125">
                    {{ show.grouping[grouping].amount }}
                  </span>
                  </div>
                </td>
                <td [colSpan]="calculateVariableColumnsAmount() + 10"></td>
              </tr>
              @for (company of companyWrappers; track company.company.uuid) {
                @if ((company.company.isTracked && grouping === 'tracked' && show.grouping.tracked.isShown)
                || (!company.company.isTracked && grouping === 'untracked' && show.grouping.untracked.isShown)) {
                  <tr [attr.data-qa]="'kpi-bulk-request-table-tr-' + company.company.name"
                      [ngClass]="is.collapsed ? 'short-sticky-group' : 'full-sticky-group'">
                    <td class="col-three-dots">
                      <div
                        [attr.data-qa]="'kpi-bulk-request-table-td-three-dots-' + grouping + '-' + company.company.name"
                        class="centered-row-container">
                        <app-three-dots-menu [matMenuTriggerFor]="menu"/>
                        <mat-menu #menu="matMenu">
                          <ul class="list">
                            <app-drop-down-item
                              [attr.data-qa]="'kpi-bulk-request-table-three-dots-set-' + grouping + '-' + company.company.name"
                              class="width-100pcnt"
                              [text]="'Set '+ (company.company.isTracked ? 'not ' : '') + 'tracked'"
                              [iconNameAndStyling]="(company.company.isTracked ? 'crossed-' : '') + 'eye.svg'"
                              (click)="updateTrackStatus(company.company, !company.company.isTracked)">
                            </app-drop-down-item>
                          </ul>
                        </mat-menu>
                      </div>
                      <div class="height-1p25"></div>
                    </td>
                    <td class="col-company-name">
                      <div class="start-column-container">
                        <div
                          *ngVar="'company-name-' + company.company.uuid as id"
                          class="h-[1.25rem] company-name flex items-center"
                          [attr.data-qa]="'kpi-bulk-request-table-td-company-name-' + grouping + '-' + company.company.name"
                          [attr.id]="id"
                          (click)="goToCompanyMetrics(company.company.uuid)"
                        >
                          <span>{{ company.company.name | linkShort : MAX_NAME_LENGTH : false : false }}
                          </span>
                          @if (company.company.name.length > MAX_NAME_LENGTH) {
                            <span
                              (mouseenter)="showCompanyNameTooltip(id, company.company.name)"
                              (mouseleave)="show.companyNameTooltip = null"
                            > ...
                            </span>
                          }
                        </div>
                        <div
                          *ngVar="company.latestNotificationData as notificationData"
                          class="h-[1.25rem] flex flex-row gap-[0.5rem] w-full"
                          [attr.data-qa]="'kpi-bulk-request-table-td-company-name-' + grouping + '-' + company.company.name + '-member-count'">
                          @if (notificationData) {
                            <div
                              *ngVar="'kpi-bulk-request-recipients-icon-'+company.company.name as id"
                              class="flex flex-row items-center black-10"
                              [attr.data-qa]="id"
                              [attr.id]="id"
                              (mouseenter)="showRequestRecipientsTooltip(id, notificationData)"
                              (mouseleave)="show.requestRecipientsTooltip = null"
                            >
                              <app-all-icons
                                [iconNameAndStyling]="'user-icon-empty.svg;icon-size-1; black-10'"
                              />
                              {{ notificationData.recipientsNames.length }}
                            </div>
                            <div
                              *ngVar="'kpi-bulk-request-sent-icon-'+company.company.name as id"
                              class="flex flex-row  items-center black-10"
                              [attr.data-qa]="id"
                              [attr.id]="id"
                              (mouseenter)="showRequestSentTooltip(id, notificationData)"
                              (mouseleave)="show.requestSentTooltip = null"
                            >
                              <app-all-icons
                                [iconNameAndStyling]="'paper-plane-empty.svg;icon-size-1; black-10'"
                              />
                              {{ DateService.convertLocalDateTimeToDaysDiff(notificationData.creationTime) }}
                            </div>
                            @if (notificationData.submissionTime) {
                              <div
                                *ngVar="'kpi-bulk-request-received-icon-'+company.company.name as id"
                                class="flex flex-row items-center black-10"
                                [attr.data-qa]="id"
                                [attr.id]="id"
                                (mouseenter)="showRequestReceivedTooltip(id, notificationData)"
                                (mouseleave)="show.requestReceivedTooltip = null"
                              >
                                <app-all-icons
                                  [iconNameAndStyling]="'thin-return-arrow.svg;icon-size-1; black-10'"
                                />
                                {{ DateService.convertLocalDateTimeToDaysDiff(notificationData.submissionTime) }}
                              </div>
                            }
                          }
                        </div>
                      </div>
                    </td>
                    @if (!is.collapsed) {
                      <td class="col-metrics">
                        <div class="start-column-container-flex-start width-6">
                          <div class="space-between-horizontal-centered height-1p25 width-100pcnt">
                            <span
                              [attr.data-qa]="'kpi-bulk-request-table-td-visible-metrics-amount-' + grouping + '-' + company.company.name">
                              {{ company.company.visibleMetricAmount }}
                              metrics
                            </span>
                            <app-button
                              [attr.data-qa]="'kpi-bulk-request-table-td-show-company-metric-settings-' + grouping + '-' + company.company.name"
                              [iconName]="'edit-outline.svg'"
                              [type]="'light-grey'"
                              [size]="'xsmall'"
                              [showIcon]="'only'"
                              [bordersSquaredShape]="'full-small-button'"
                              (buttonClick)="showCompanyMetricSettings(company)"
                            />
                          </div>
                        </div>
                        <div class="height-1p25"></div>
                      </td>
                      <td class="sticky-position blank-space"></td>
                      <td
                        *ngVar="company.linkForm.getFormRawValue() as companyValue"
                        class="col-link">

                        <div class="start-column-container-flex-start column-gap-0p25">
                          <div class="space-between-horizontal-centered height-1p25 width-100pcnt">
                            <app-switcher
                              [attr.data-qa]="'kpi-bulk-request-table-td-toggle-msl-' + grouping + '-' + company.company.name"
                              #mslSingleSwitcher
                              [id]="'kpi-bulk-request-table-td-toggle-msl-' + company.company.uuid"
                              class="small-switcher"
                              [checked]="!!company.linkForm.form.value.uuid"
                              (checkedChanged)="toggleMsl(company)"
                            />
                            @if (company.linkForm && company.linkForm.form.getRawValue().password) {
                              <div class="centered-row-container row-gap-0p5">
                                <div
                                  *ngVar="'kpi-bulk-request-table-td-copy-msl-link-' + grouping + '-' + company.company.name as id"
                                  [attr.id]="id"
                                >
                                  <app-button
                                    [attr.data-qa]="id"
                                    [iconName]="'link.svg'"
                                    [type]="'light-grey'"
                                    [size]="'xsmall'"
                                    [showIcon]="'only'"
                                    [bordersSquaredShape]="'full-small-button'"
                                    (buttonClick)="copyToClipboard(company.linkForm.form.getRawValue().token)"
                                    (mouseenter)="showCopyLinkTooltip(id)"
                                    (mouseleave)="show.copyLinkTooltip = null"
                                  />
                                </div>
                                <div
                                  *ngVar="'kpi-bulk-request-table-td-copy-pass-' + grouping + '-' + company.company.name as id"
                                  [attr.id]="id"
                                >
                                  <app-button
                                    [attr.data-qa]="id"
                                    [iconName]="'key.svg'"
                                    [type]="'light-grey'"
                                    [size]="'xsmall'"
                                    [showIcon]="'only'"
                                    [bordersSquaredShape]="'full-small-button'"
                                    (buttonClick)="copyToClipboard(company.linkForm.form.getRawValue().password)"
                                    (mouseenter)="showCopyPasswordTooltip(id)"
                                    (mouseleave)="show.copyPasswordTooltip = null"
                                  />
                                </div>
                                <div
                                  *ngVar="'kpi-bulk-request-table-td-copy-creds-' + grouping + '-' + company.company.name as id"
                                  [attr.id]="id"
                                >
                                  <app-button
                                    [attr.data-qa]="id"
                                    [iconName]="'copy-outline.svg'"
                                    [type]="'light-grey'"
                                    [size]="'xsmall'"
                                    [showIcon]="'only'"
                                    [bordersSquaredShape]="'full-small-button'"
                                    (buttonClick)="copyToClipboard(buildCredentials(company))"
                                    (mouseenter)="showCopyCredentialsTooltip(id)"
                                    (mouseleave)="show.copyCredentialsTooltip = null"
                                  />
                                </div>
                                <div
                                  #buttonPoc
                                  [id]="'kpi-bulk-request-table-td-update-contact-' + grouping + '-' + company.company.name">
                                  <app-button
                                    [attr.data-qa]="'kpi-bulk-request-table-td-update-contact-' + grouping + '-' + company.company.name"
                                    [iconName]="(companyValue.contact.name || companyValue.contact.email) ? 'poc.svg' : 'user-icon-empty.svg'"
                                    [type]="'light-grey'"
                                    [size]="'xsmall'"
                                    [showIcon]="'only'"
                                    [bordersSquaredShape]="'full-small-button'"
                                    (buttonClick)="showUpdateContact(company)"
                                    (mouseenter)="showTooltipPOG(buttonPoc.id, companyValue.contact)"
                                    (mouseleave)="showTooltipPOG(null, null)"
                                  />
                                </div>
                              </div>
                            }
                          </div>
                          <div class="height-1p25"></div>
                        </div>
                      </td>
                    }
                    <td class="sticky-position blank-space"></td>
                    <td class="col-type">
                      <div class="start-column-container-flex-start column-gap-0p25">
                        <div class="column-space-round height-1p25">
                          <div class="start-row-container row-gap-0p25">
                            <div class="dot bg-main-8"></div>
                            <span
                              [attr.data-qa]="'kpi-bulk-request-table-td-actual-' + grouping + '-' + company.company.name"
                              class="line-height-120">
                              Actual
                            </span>
                          </div>
                        </div>
                        <div class="column-space-round height-1p25">
                          <div class="start-row-container row-gap-0p25">
                            <div class="dot bg-orange-10"></div>
                            <span
                              [attr.data-qa]="'kpi-bulk-request-table-td-budget-' + grouping + '-' + company.company.name"
                              class="line-height-120">
                              Budget
                            </span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="col-permitted-period">
                      @if (company.linkForm) {
                        <div class="centered-column-container column-gap-0p25">
                          <div class="centered-row-container row-gap-0p5">
                            <app-selector
                              [attr.data-qa]="'kpi-bulk-request-table-td-period-selector-actual-from-' + grouping + '-' + company.company.name"
                              class="width-4p5"
                              [formControl]="company.linkForm.form.controls.actual.controls.fromPeriod"
                              [selectedItem]="company.linkForm.form.getRawValue().actual?.fromPeriod"
                              [outerClass]="'control-shrinked-container'"
                              [defaultPlaceholder]="'-'"
                              [data]="company.linkForm.actualPeriods.from.length ? [resetText].concat(company.linkForm.actualPeriods.from) : []"
                              (itemEmitter)="updatePeriodSelector(company, 'actual', $event, company.linkForm.form.getRawValue().actual?.tillPeriod)"
                            />
                            <app-selector
                              [attr.data-qa]="'kpi-bulk-request-table-td-period-selector-actual-till-' + grouping + '-' + company.company.name"
                              class="width-4p5"
                              [formControl]="company.linkForm.form.controls.actual.controls.tillPeriod"
                              [selectedItem]="company.linkForm.form.getRawValue().actual?.tillPeriod"
                              [outerClass]="'control-shrinked-container'"
                              [defaultPlaceholder]="'-'"
                              [data]="company.linkForm.actualPeriods.till.length ? [resetText].concat(company.linkForm.actualPeriods.till) : []"
                              (itemEmitter)="updatePeriodSelector(company, 'actual', company.linkForm.form.getRawValue().actual?.fromPeriod, $event)"
                            />
                          </div>
                          <div class="centered-row-container row-gap-0p5">
                            <app-selector
                              [attr.data-qa]="'kpi-bulk-request-table-td-period-selector-budget-from-' + grouping + '-' + company.company.name"
                              class="width-4p5"
                              [formControl]="company.linkForm.form.controls.budget.controls.fromPeriod"
                              [selectedItem]="company.linkForm.form.getRawValue().budget?.fromPeriod"
                              [outerClass]="'control-shrinked-container'"
                              [defaultPlaceholder]="'-'"
                              [data]="company.linkForm.budgetPeriods.from.length ? [resetText].concat(company.linkForm.budgetPeriods.from) : []"
                              (itemEmitter)="updatePeriodSelector(company, 'budget', $event, company.linkForm.form.getRawValue().budget?.tillPeriod)"
                            />
                            <app-selector
                              [attr.data-qa]="'kpi-bulk-request-table-td-period-selector-budget-till-' + grouping + '-' + company.company.name"
                              class="width-4p5"
                              [formControl]="company.linkForm.form.controls.budget.controls.tillPeriod"
                              [selectedItem]="company.linkForm.form.getRawValue().budget?.tillPeriod"
                              [outerClass]="'control-shrinked-container'"
                              [defaultPlaceholder]="'-'"
                              [data]="company.linkForm.budgetPeriods.till.length ? [resetText].concat(company.linkForm.budgetPeriods.till) : []"
                              (itemEmitter)="updatePeriodSelector(company, 'budget', company.linkForm.form.getRawValue().budget?.fromPeriod, $event)"
                            />
                          </div>
                        </div>
                      }
                    </td>
                    <td class="sticky-position blank-space"></td>
                    <!--actual and budget have the same period length-->
                    @for (yearWrapper of periodsByYears; track yearWrapper.year) {
                      @if (!yearWrapper.isShown) {
                        <td class="fix-w-2p5"></td>
                      } @else {
                        <ng-container *ngVar="findFirstWithYear(yearWrapper.year, company.periods.actual) as firstPeriodIndex">
                          @for (period of yearWrapper.periods; track period; ) {
                            <td class="fix-w-2p5" *ngVar="firstPeriodIndex + $index as i">
                              <div class="centered-column-container column-gap-0p625">
                                @for (role of PeriodRoles; track role) {
                                  <div *ngVar="company.periods[role][i] as metricData"
                                       [attr.data-qa]="'kpi-bulk-request-table-td-period-icon-' + grouping + '-' + period + '-' + role + '-' + company.company.name"
                                       [id]="company.company.name + '-' + period + '-' + role"
                                       #tooltip
                                       class="centered-column-container"
                                       (mouseenter)="showTooltipCompanyWrapper(tooltip.id, metricData)"
                                       (mouseleave)="showTooltipCompanyWrapper(null, null)">
                                    @if (!metricData.isPersisted) {
                                      <!--No period: show nothing-->
                                      <div data-qa="empty" class="width-1p25 height-1p25"></div>
                                    } @else if (!metricData.isRequested && !metricData.isEmpty) {
                                      <!--Non-requested period with data: grey circle with check-->
                                      <app-all-icons data-qa="grey-checked"
                                                     [iconNameAndStyling]="'kpi-period-status-with-data-not-requested.svg;icon-size-1p25'"/>
                                    } @else if (!metricData.isRequested && metricData.isEmpty) {
                                      <!--Non-requested period without data: grey circle without check-->
                                      <app-all-icons data-qa="grey-unchecked"
                                                     [iconNameAndStyling]="'kpi-period-status-without-data-not-requested.svg;icon-size-1p25; black-4'"/>
                                    } @else if (metricData.isRequested && metricData.isEmpty) {
                                      <!--Requested period without data: blue circle without check-->
                                      <app-all-icons data-qa="blue-unchecked"
                                                     [iconNameAndStyling]="'kpi-period-status-without-data.svg;icon-size-1p25; main-portal'"/>
                                    } @else if (metricData.isRequested && !metricData.isEmpty) {
                                      <!--Requested period with data: blue circle with check-->
                                      <app-all-icons data-qa="blue-checked"
                                                     [iconNameAndStyling]="'kpi-period-status-with-data.svg;icon-size-1p25; main-portal'"/>
                                    }
                                  </div>
                                }
                              </div>
                            </td>
                          }
                        </ng-container>
                      }
                      <th class="sticky-position blank-space no-hover z-0"></th>
                    }
                    <td></td>
                  </tr>
                }
              }
            }
          </tbody>
        </table>
      </div>
    } @else if (companyWrappers && !companyWrappers.length) {
      <app-empty-state-standard
        [isAdmin]="is.admin"
        [heading]="'No companies yet'"
        [buttonText]="'Company'"
        [buttonIconName]="'plus.svg'"
        (buttonClick)="goToCompanyMetrics(null)"/>
    } @else if (companyWrappers === undefined) {
      <app-standard-skeleton-table
        class="overflow-hidden"
        [trAmount]="40"
        [tdAmount]="15"
        [headers]="['', 'Company', 'Metrics', '', 'Link', '', 'Type', 'Permitted periods', '', '', '', '', '', '', '']"
      />
    }
  </div>
</section>

@if (show.updateMetricsModal) {
  <app-kpi-update-metrics-visibility-bulk-request
    [allCompanyWrappers]="selected.companiesForManageMetricsModal"
    [selectedCompanyWrapper]="selected.companyWrapper"
    [metricGroups]="selected.companyMetricGroups"
    (closeEmitter)="updateCompanyMetric($event)"
  />
}

@if (show.managePeriodsModal) {
  <app-modal-manage-periods
    [parent]="'bulk-companies'"
    [companies]="selected.companiesForManagePeriodsModal"
    [periods]="selected.periodsForManagePeriodsModal"
    (closeModal)="closeModalManagePeriods($event)">
  </app-modal-manage-periods>
}
@if (show.deletePeriodsModal) {
  <app-kpi-modal-delete-periods
    [periods]="selected.periodsForDeletePeriodsModal"
    [orgUUID]="selected.org.uuid"
    [companies]="selected.companiesForManagePeriodsModal"
    (closeModal)="closeDeletePeriodsModal($event)"
  />
}

@if (show.deleteAllMSLModal) {
  <app-modal-dialog
    [header]="mslDeletionModalTitle()"
    [showIUnderstand]="true"
    [useStandardList]="false"
    [mainText]="mslDeletionModalMainText()"
    [hideAllText]="true"
    [showInput]="!deletionInProcess"
    [modalButtons]="mslDeletionModalButtons()"
    (isConfirmed)="deleteAllMSL($event)"
  />
}

@if (show.deleteOneMSLModal) {
  <app-modal-dialog
    header="Delete shared link"
    [mainText]="singleMslDeletionModalMainText()"
    (isConfirmed)="deleteOneMSLConfirmed($event)"
  />
}

@if (show.createAllMSLModal) {
  <app-modal-dialog
    [header]="mslCreationModalTitle()"
    [hideAllText]="true"
    [showIUnderstand]="false"
    [showInput]="false"
    [modalButtons]="{}"
  />
}

<app-tooltip
  *ngIf="show.tooltip"
  [attr.data-qa]="'kpi-bulk-request-tooltip'"
  [coordinates]="show.tooltip.tooltipCoordinates">
  @if (show.tooltip.companyWrapper) {
    <div
      *ngVar="show.tooltip.companyWrapper as metricData"
      class="start-column-container caption-2">
      {{ metricData.period | date: 'MMM, yyyy' }}
      @if (metricData.isPersisted && !metricData.isRequested && !metricData.isEmpty) {
        <span>Period is not requested</span>
        <span>Period has data</span>
      } @else if (metricData.isPersisted && !metricData.isRequested && metricData.isEmpty) {
        <span>Period is not requested</span>
        <span>Period has no data</span>
      } @else if (metricData.isPersisted && metricData.isRequested && metricData.isEmpty) {
        <span>Period is requested</span>
        <span>Period has no data</span>
      } @else if (metricData.isPersisted && metricData.isRequested && !metricData.isEmpty) {
        <span>Period is requested</span>
        <span>Period has data</span>
      }
    </div>
  }
</app-tooltip>

@if (show.bulkMslModal) {
  <app-kpi-modal-bulk-msl
    [uniquePeriods]="uniquePeriods"
    [orgUUID]="selected.org.uuid"
    [companyWrappers]="companyWrappers"
    (closeEmitter)="closeModalBulkMsl($event)"
  />
}


@if (show.kpiRequestModal) {
  <app-kpi-modal-bulk-kpi-request
    [companyWrappers]="companyWrappers"
    (closeEmitter)="closeKpiRequestModal($event)"
  />
}

@if (show.allMslTooltip) {
  <app-tooltip
    data-qa="all-msl-tooltip"
    [title]="show.allMslTooltip.tooltipText"
    [coordinates]="show.allMslTooltip.tooltipCoordinates"
  />
}

@if (selected.mslFormForContactUpdate) {
  <app-kpi-modal-msl-update-contact
    [companyForm]="selected.mslFormForContactUpdate"
    (closeEmitter)="closeUpdateContact($event)"
  />
}


@if (show.requestRecipientsTooltip) {
  <app-tooltip
    data-qa="request-recipients-tooltip"
    class="simple-table-popup black-14 whitespace-pre-line"
    [title]="show.requestRecipientsTooltip.tooltipText"
    [text]="show.requestRecipientsTooltip.titleText"
    [coordinates]="show.requestRecipientsTooltip.tooltipCoordinates"
  >
  </app-tooltip>
}

@if (show.requestSentTooltip) {
  <app-tooltip
    data-qa="request-recipients-tooltip"
    class="simple-table-popup black-14"
    [title]="show.requestSentTooltip.tooltipText"
    [text]="'Bulk request sent'"
    [coordinates]="show.requestSentTooltip.tooltipCoordinates"
  >
  </app-tooltip>
}

@if (show.requestReceivedTooltip) {
  <app-tooltip
    data-qa="request-recipients-tooltip"
    class="simple-table-popup black-14"
    [title]="show.requestReceivedTooltip.tooltipText"
    [text]="'Data submitted'"
    [coordinates]="show.requestReceivedTooltip.tooltipCoordinates"
  >
  </app-tooltip>
}

@if (show.companyNameTooltip) {
  <app-tooltip
    data-qa="company-name-tooltip"
    class="simple-table-popup black-14"
    [title]="show.companyNameTooltip.tooltipText"
    [coordinates]="show.companyNameTooltip.tooltipCoordinates"
  >
  </app-tooltip>
}

@if (show.copyCredentialsTooltip) {
  <app-tooltip
    data-qa="company-name-tooltip"
    class="simple-table-popup black-14"
    [title]="show.copyCredentialsTooltip.tooltipText"
    [coordinates]="show.copyCredentialsTooltip.tooltipCoordinates"
  >
  </app-tooltip>
}

@if (show.copyLinkTooltip) {
  <app-tooltip
    data-qa="company-name-tooltip"
    class="simple-table-popup black-14"
    [title]="show.copyLinkTooltip.tooltipText"
    [coordinates]="show.copyLinkTooltip.tooltipCoordinates"
  >
  </app-tooltip>
}

@if (show.copyPasswordTooltip) {
  <app-tooltip
    data-qa="company-name-tooltip"
    class="simple-table-popup black-14"
    [title]="show.copyPasswordTooltip.tooltipText"
    [coordinates]="show.copyPasswordTooltip.tooltipCoordinates"
  >
  </app-tooltip>
}

@if (show.pocTooltip) {
  <app-tooltip
    data-qa="company-name-tooltip"
    class="simple-table-popup black-14"
    [title]="show.pocTooltip.tooltipTitle"
    [text]="show.pocTooltip.tooltipText"
    [coordinates]="show.pocTooltip.tooltipCoordinates"
  >
  </app-tooltip>
}
